import DraftAggrementComponent from "../components/draftAggrement/DraftAggrement";
import UploadDraftLoading from "../components/loaders/UploadDraftLoading";
import { useApplication } from "../hooks/useApplication";
import { useUser } from "../hooks/useUser";

const Page = (props) => {
  const application = useApplication();
  const user = useUser();
  if (!application || !user) {
    return <UploadDraftLoading />;
  }
  return <DraftAggrementComponent {...props} />;
};

export default Page;
